import table from "./table.json";
import approveRequestDialog from "./approve-request-dialog.json";
import declineRequestDialog from "./decline-request-dialog.json";

export default {
  table,
  approveRequestDialog,
  declineRequestDialog,
};
